import { render, staticRenderFns } from "./CalculationDetails.vue?vue&type=template&id=bf6fa900"
import script from "./CalculationDetails.vue?vue&type=script&lang=js"
export * from "./CalculationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports